import React from 'react'
import { Row, Col } from 'antd';
import { Helmet } from 'react-helmet'
import ContactHeader from './ContactHeader'
import ContactForm from './ContactForm'


const Contact = () => {
    return (
        <>
            <Helmet>
                <title>Contact - Vroom</title>
            </Helmet>
            <Row className="sec1">
                <Col span={24}>
                    <ContactHeader />
                    <hr className="line-break" />
                    <section >
                        <ContactForm />
                    </section>
                </Col>
            </Row>

        </>
    )
}

export default Contact
